import { render, staticRenderFns } from "./ManterAbasView.vue?vue&type=template&id=16644b68&scoped=true"
import script from "./ManterAbasView.vue?vue&type=script&lang=js"
export * from "./ManterAbasView.vue?vue&type=script&lang=js"
import style0 from "./ManterAbasView.vue?vue&type=style&index=0&id=16644b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16644b68",
  null
  
)

export default component.exports